import AccountLinkTour from './tours/AccountLinkTour';
import AddMaterialTour from './tours/AddMaterialTour';

const start = () => {
  AccountLinkTour.start();
  AddMaterialTour.start();
};

export default { start };
